class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange.bind(this));
    this.disableButtonUpdate = false;
    if (this.dataset.disableButtonLoading) {
      this.disableButtonUpdate = JSON.parse(this.dataset.disableButtonLoading);
    }
    this.updateById = false;
    if (this.dataset.setVariantById) {
      this.updateById = JSON.parse(this.dataset.setVariantById);
    }
  }

  onVariantChange(event) {

    window.variantChangeId = event.target.dataset.variantId;

    window.atcButton = '<strong>' + window.variantStrings.addToCart + '</strong>';
    window.atcButton2 = '<strong class="relative top-2">' + window.variantStrings.addToCart + '</strong>';
    window.atcButton3 = '<strong class="relative">' + window.variantStrings.addToCart + '</strong>';

    // pre-order
    if (event.target.dataset)  {
      if (event.target.dataset.preOrder) {
        if (event.target.dataset.preOrder.length > 0) {
          window.atcButton = '<strong>PRE-ORDER</strong><br>' + event.target.dataset.preOrder + '';
          window.atcButton2 = '<strong>PRE-ORDER</strong><br>' + event.target.dataset.preOrder + '';
          window.atcButton3 = '<strong>PRE-ORDER</strong>';
          // set property
          if (document.querySelector('product-info product-form [name="properties[Pre order]"]')) {
            document.querySelector('product-info product-form [name="properties[Pre order]"]').value = event.target.dataset.preOrder;
          }
          // show helper
          if (document.querySelector('[data-no-subscription]')) {
            document.querySelector('[data-no-subscription]').classList.remove('h-0');
          }
          // set discount
          if (event.target.dataset.preOrderDiscount) {
            if (event.target.dataset.preOrderDiscount.length > 0) {
              let object = {
                "discount": "true",
                "amount": event.target.dataset.preOrderDiscount,
                "type": "percent",
                "label": "Pre-order discount",
                "combination": "",
                "cart_totals": 0
              }
              if (document.querySelector('product-info product-form [name="properties[_discount]"]')) {
                document.querySelector('product-info product-form [name="properties[_discount]"]').value = JSON.stringify(object);
              }
            }
          } else {
            if (document.querySelector('product-info product-form [name="properties[_discount]"]')) {
              document.querySelector('product-info product-form [name="properties[_discount]"]').value = '';
            }
          }
        }
      } else {
        // unset property
        if (document.querySelector('product-info product-form [name="properties[Pre order]"]')) {
          document.querySelector('product-info product-form [name="properties[Pre order]"]').value = '';
        }
        // hide helper
        if (document.querySelector('[data-no-subscription]')) {
          document.querySelector('[data-no-subscription]').classList.add('h-0');
        }
        // remove discount
        if (document.querySelector('product-info product-form [name="properties[_discount]"]')) {
          document.querySelector('product-info product-form [name="properties[_discount]"]').value = '';
        }
      }
    }

    if (!this.updateById) {
      this.updateOptions();
      this.updateMasterId();
    } else {
      this.updateMasterIdById(event);
    }
    if (!this.disableButtonUpdate) {
      if (typeof this.dataset.fetchMePls !== 'undefined') {
        this.toggleAddButton(true, '', false);
      }
    }
    if (!this.currentVariant) {
      if (!this.disableButtonUpdate) {
        if (typeof this.dataset.fetchMePls !== 'undefined') {
          this.toggleAddButton(true, '', true);
          this.setUnavailable();
        }
      }
    } else {
      this.updateMedia(event);
      this.updateURL();
      this.updateSelectedOptionLabel();
      this.updateVariantInput();
      if (typeof this.dataset.fetchMePls !== 'undefined') {
        this.renderProductInfo();
      } else {
        applyDiscounts();
      }
      this.dispatchVariantChange();
    }
    if (document.querySelector('[data-drop-content]')) {
      let selectedColor = event.target.value;
      document.querySelector('[data-drop-content] button .button-content').innerHTML = document.querySelector('[data-dropdown-value="' + selectedColor + '"]').innerHTML;
    }
    if (document.querySelector('[data-dropdown-label]')) {
      document.querySelectorAll('[data-dropdown-label]').forEach((label) => {
        label.classList.add('hidden');
      });
      document.querySelectorAll('[data-dropdown-label]').forEach((label) => {
        let selectedColor = event.target.value;
        if (label.dataset.dropdownLabel.trim().toLowerCase() == selectedColor.trim().toLowerCase()) {
          label.classList.remove('hidden');
        }
      });
    }

    if (document.querySelector('[data-quiz-recommended-variant]')) {
      let variant_id = event.target.dataset.variantId;
      let recommended_variant = document.querySelector('[data-quiz-recommended-variant]').dataset.quizRecommendedVariant;
      if (variant_id == recommended_variant) {
        document.querySelector('[data-group-quiz]').classList.add('active');
      } else {
        document.querySelector('[data-group-quiz]').classList.remove('active');
      }
    }

  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterIdById(event) {
    let theId = event.target.dataset.variantId;
    this.getVariantData().forEach((variant) => {
      if (variant.id == parseInt(theId)) {
        this.currentVariant = variant;
      }
    });
    this.currentVariant.title = event.target.value;
  }

  updateMasterId() {
      
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  dispatchVariantChange() {
    document.dispatchEvent(
      new CustomEvent('variant-change', {
        bubbles: true,
        variant: this.currentVariant,
        detail: {
          variant: this.currentVariant,
        },
      })
    );
  }

  updateMedia(event) {
    let variantId = event.target.dataset.variantId;
    if (typeof variantId === 'undefined') {
      variantId = event.target.querySelector('input:checked').dataset.variantId;
    }
    let variantSlider = document.querySelectorAll('[data-product-slider-variant="' + variantId + '"]');
    let defaultSlider = document.querySelectorAll('[data-product-slider-variant="default"]')
    let sliderArr = document.querySelectorAll('[data-product-slider-variant]');

    if (document.querySelector('[data-product-slider-variant="' + variantId + '"]')) {
      sliderArr.forEach((slide) => {
        slide.classList.add('hidden')
      })
      variantSlider.forEach((slider) => {
        slider.classList.remove('hidden')
      })
    } else {
      sliderArr.forEach((slide) => {
        slide.classList.add('hidden')
      })
      defaultSlider.forEach((slider) => {
        slider.classList.remove('hidden')
      })
    }
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateSelectedOptionLabel() {
    if (!this.currentVariant || !this.querySelector('[data-selected-option-label]')) return;
    this.querySelector('[data-selected-option-label]').innerHTML = this.currentVariant.title;
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        document.getElementById(`price-${this.dataset.section}`)?.classList.remove('hidden');
        if (this.currentVariant) {
          this.toggleAddButton(!this.currentVariant.available, window.variantStrings.notify_me);
        }

        // Update the inventory quantity hidden input
        const inventoryQtyDestination = document
          .querySelector(`#product-form-${this.dataset.section}`)
          .querySelector('input[name="inventory_quantity"]');
        const inventoryQtySource = html
          .querySelector(`#product-form-${this.dataset.section}`)
          .querySelector('input[name="inventory_quantity"]');
        inventoryQtyDestination.value = inventoryQtySource.value;

        applyDiscounts();
      });
  }

  /**
   * toggleAddButton
   * @param {Boolean} disable
   * @param {String} text
   * @param {Boolean} modifyClass
   * @returns {void}
   */
  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]');
    const addButtonArr = document.querySelectorAll('[data-track-add-to-cart-new="true"]');
    const addButtonText = addButton.querySelector('[data-add-to-cart-button-text]');

    if (!addButton || !addButtonText) return;

    if (disable) {

      document.querySelectorAll('.help-me-find').forEach((find) => {
        find.classList.add('hidden');
      });
      addButton.classList.add('hidden');
      addButton.setAttribute('disabled', true);
      if (text) addButtonText.innerHTML = text;
      addButtonArr.forEach((button) => {
        button.classList.remove('button--funnel');
        button.classList.add('button--black');
        button.classList.add('notify-me');
        if (text) button.innerHTML = text;
      })
      document.querySelectorAll('.notify-me').forEach((notify) => {
        notify.addEventListener('click', (e) => {
          document.querySelector('.help-me-find').click();
        });
      });
 
    } else {
      if (document.querySelector('.help-me-find')) {
        let jsonData = JSON.parse(document.querySelector('[data-promo-offer-data]').dataset.promoOfferData);
        let variantId = this.querySelector('input[data-option-input]:checked').dataset.variantId;
        jsonData.productVariant = variantId;
        document.querySelector('[data-promo-offer-data]').dataset.promoOfferData = JSON.stringify(jsonData);
        document.querySelectorAll('.help-me-find').forEach((find) => {
          find.classList.remove('hidden');
        });
      } else {
        addButton.classList.remove('hidden');
        addButton.removeAttribute('disabled');
        addButtonText.innerHTML = window.atcButton;
        addButtonArr.forEach((button, i) => {
          button.classList.remove('button--black');
          button.classList.add('button--funnel');
          button.classList.remove('notify-me');
          if (i == 0) {
            button.innerHTML = window.atcButton2;
          } else {
            button.innerHTML = window.atcButton3;
          }
        })
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.innerHTML = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('hidden');
  }

  getVariantData() {
    if (window.ab_test_json) {
      this.variantData = JSON.parse(document.querySelector('#product-ab-data-2').textContent);
    } else {
      this.variantData =
      this.variantData || JSON.parse(document.querySelector('#product-ab-data').textContent);
    }
    return this.variantData;
  }
}

if (!customElements.get('variant-selects')) {
  customElements.define('variant-selects', VariantSelects);
}

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    this.updateOptions();
    this.updateMasterId();
    if (!this.disableButtonUpdate) {
      this.highlightOptions();
    }
  }

  onVariantChange(event) {
    super.onVariantChange(event);
    if (!this.disableButtonUpdate) {
      this.highlightOptions();
    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }

  /*
   * Check for each option value if the other one/two selected variant options are available
   */
  highlightOptions() {
    // If no selected element make all available
    let selectedElement = event
      ? event.target
      : this.querySelector('[data-option-group] input[checked]');
    if (!selectedElement) {
      this.querySelectorAll('[data-option-group]').forEach((option) => {
        option.querySelectorAll('[data-option]').forEach((optionEl) => {
          let label = optionEl.querySelector('[data-option-label]');
          label.classList.remove('option__label--disabled');
        });
      });
      return;
    }

    // Loop over option groups
    this.querySelectorAll('[data-option-group]').forEach((option) => {
      // Get index from option group (1, 2 or 3)
      const optionIndex = parseInt(option.dataset.optionGroup);

      // Create compare options from group, remove selected option based on index
      const compareOptions = [...this.options].filter((option, index) => index != optionIndex);

      // Loop over possible values for option group
      option.querySelectorAll('[data-option]').forEach((optionEl) => {
        let label = optionEl.querySelector('[data-option-label]'),
          input = optionEl.querySelector('[data-option-input]'),
          value = input.value;

        // Match option availability and check if the two current options are available for value
        let match = this.getVariantData().filter((variant) => {
          // Get available variants where the current option index is the option value
          if (variant.options[optionIndex] == value && variant.available) {
            // Create variant options, remove option based on option value
            const variantOptions = [...variant.options].filter(
              (option, index) => index != optionIndex
            );

            // Check if compare options is the same as variant options
            return variantOptions.every(
              (item, index) => item.toLowerCase() === compareOptions[index].toLowerCase()
            );
          }

          return false;
        });

        // Enable disable variant options
        label.classList.toggle('option__label--disabled', match.length == 0);
      });
    });
  }
}

if (!customElements.get('variant-radios')) {
  customElements.define('variant-radios', VariantRadios);
}
